'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var CardContent = _interopDefault(require('@material-ui/core/CardContent'));
var Divider = _interopDefault(require('@material-ui/core/Divider'));
var styledComponents = require('./styled-components.js');

var CardWithChart = function (props) {
    var children = props.children, title = props.title;
    return (React__default.createElement(styledComponents.StyledCard, null,
        React__default.createElement(CardContent, null,
            React__default.createElement(styledComponents.PaddedTypography, { variant: 'h5', component: 'h2' }, title)),
        React__default.createElement(Divider, null),
        React__default.createElement(CardContent, null, children)));
};

module.exports = CardWithChart;
